import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { APP_CONFIG, IAppConfig } from '@app/core/config';
import { UtilsService } from '@app/core/services';
import { FriendSelectList } from '../models';


@Injectable({
	providedIn: 'root'
})
export class FriendPublicService {

	private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

	constructor(
		@Inject(APP_CONFIG) private appConfig: IAppConfig,
		private http: HttpClient,
		private utilsService: UtilsService
	) {
	}

	getMyFriends(): Observable<FriendSelectList[]> {

		const url = `${this.appConfig.apiEndpoint}/new-core/friends/lookup`;
		return this.http.get<FriendSelectList[]>(url, { headers: this.headers })
			.pipe(map(this.utilsService.handleResponse));
	}
}
